var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-info thank-you-block"},[_c('div',{staticClass:"general-info__container"},[_c('div',{staticClass:"general-info-department"},[_c('div',{staticClass:"general-info-department__thank"},[_c('BlockThankYou')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }